import { render, staticRenderFns } from "./FloatingShortcuts.vue?vue&type=template&id=6dfd5077&"
import script from "./FloatingShortcuts.vue?vue&type=script&lang=js&"
export * from "./FloatingShortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports